import type { UserProfileData, UserProfileUpdateRequest } from '../services/types/userProfile.types';

export const USER_PROFILE_UPDATE_KEYS = [
  'firstName',
  'lastName',
  'gender',
  'jiraKey',
  'jiraAccountId',
  'designationId',
  'roleId',
  'designationAppointDate',
  'jiraApiToken',
  'departmentId',
  'permissionLevel',
  'employmentType',
  'companyJoinedDate',
  'probationStartDate',
  'probationEndDate',
  'confirmationDate',
  'resignedDate',
  'functionalTeamId',
  'teamJoinedDate',
  'functionalTeamIdSecondary',
  'secondaryTeamJoinedDate',
] as const satisfies ReadonlyArray<keyof UserProfileUpdateRequest>;

function normField(a: unknown, b: unknown): boolean {
  const x = a === '' ? null : a;
  const y = b === '' ? null : b;
  return x === y;
}

export function buildDirtyProfileUpdate(initial: UserProfileData, current: UserProfileData): UserProfileUpdateRequest {
  const out: UserProfileUpdateRequest = {};
  for (const key of USER_PROFILE_UPDATE_KEYS) {
    const before = initial[key as keyof UserProfileData];
    const after = current[key as keyof UserProfileData];
    if (!normField(before, after)) {
      (out as Record<string, unknown>)[key] = after as unknown;
    }
  }
  return out;
}
